import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import axios from "axios";
import pdf from "../../Assets/RajatAgrawal.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  // const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  // const [spojRank, upadteSpojRank] = useState(0);
  // const [hackerrank, upadteHackerank] = useState(0);
  // const [sem, upadateSem] = useState(0);
  // const [cgpa, upadteCgpa] = useState(0);

  // useEffect(() => {
  //   axios
  //     .get(uri)
  //     .then((res) => {
  //       upadteSpojRank(res.data.message[0].spojRank);
  //       upadteHackerank(res.data.message[1].hackerrank);
  //       upadteCgpa(res.data.message[2].cgpa);
  //       upadateSem(res.data.message[3].sem);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Member Technical Staff 4 [Nutanix Pvt Ltd]"
              date="August 2020 - Present"
              content={[
                "Winner SAAS Hackathon 1.0 (2022) @Nutanix",
                "Designed and developed passwordless login @Nutanix",
                "Working in Customer Identity and Access Management (CIAM) team",
                "Worked on adding Tenancy and providing framework for migration of services to Multi tenant architecture, used to upsell products to customers",
                "Working on device authentication flow and adaptive user authentication using device fingerprint"
              ]}
            />
            <Resumecontent
              title="Member Technical Staff 3 [Nutanix Pvt Ltd]"
              date="December 2020 - July 2020"
              content={[
                "Worked on building FEDRamp compliant Systems, Adding MFA to improve security and FIDO2 with webauthn for passwordless",
                "Improved MFA and other security features related to Identity",
                "Filed Patent on Monetization aware apikeys",
                "Built FedRAMP compliant Identity system and Apikeys service",
                "Migrated UI from backbone js to React Js",
                "Provided talk on password-less login with FIDO2 and webauthN",
                "Worked on designing mtls enabled systems across organisation for zero trust environment"
              ]}
            />
              <Resumecontent
                  title="Backend Developer [Delhivery Pvt Ltd ]"
                  date="June 2019 - November 2020"
                  content={[
                      "Worked on feature development and maintainance of Identity and Access Management System at Delhivery. Present IAM system consist of\n" +
                      "two services, UMS (user store) and Keycloak (identity provider). Worked on making services inside delhivery Oauth2 compliant using Oauth2\n" +
                      "authorisation flows and openId protocol. Made use of client credential flow, PKCE code flow and implicit flow for token exchange in various\n" +
                      "services across Delhivery.",
                      "Created custom SPI for implementing TOTP and password reset functionalities in keycloak since it was not provided out of the box.",
                      "Worked on porting existing User Management System (UMS) to Keycloak service and it’s integration with other services.",
                      "Worked on designing indexes and migrating queries to ElasticSearch"
                  ]}
              />
              <Resumecontent
                  title="BACKEND INTERN [Delhivery Pvt Ltd]"
                  date="January 2019 - June 2019"
                  content={[
                      "Worked on building UMS (IAM service) to a highly scalable system with decreased latency and improved SLA, achieved it by optimizing several\n" +
                      "machine critical areas like rule engine and eradicating complex joins via materialized views.",
                      "During my Internship have had experience of working on python, flask, psql along with integration of AWS services such as lambda, sqs, kinesis\n" +
                      "using serverless",
                  ]}
              />
              <Resumecontent
                  title="Intern, Android Development [Lithion Power]"
                  date="April 2018 - June 2018"
                  content={[
                      "Remote Internship for android application development responsibility was to work on building the entire Android mobile application, from\n" +
                      "scratch.",
                      "Made use of REST Api call’s and display details of batteries to end users that were drivers and owners. Users can have update of their\n" +
                      "assets state, location and also location of nearby of electric pumps",
                  ]}
              />
              <Resumecontent
                  title="UG Research Intern [IIIT-NR]"
                  date="April 2018 - June 2018"
                  content={[
                      "Internship comprises of predicting Probability of Default (PD) using extracted features from dataset of 10 branches of a bank containing details\n" +
                      "of loans in corporate class",
                      "Focused on content research and studying technical skills required for data pre‑processing and\n" +
                      "feature extraction. My task was to extract the best feature for prediction using random feature selection and generating various decision trees",
                  ]}
              />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="COMPUTER SCIENCE AND ENGINEERING [LNMIIT, Jaipur] "
              date="2015 - 2019"
              content={[`CGPA: 8.19/10.00`]}
            />
            <Resumecontent
              title="12TH BOARD CBSE [Sri Chaitanya Techno School, Visakhapatnam]"
              date="2012 - 2014"
              content={["Percentage: 90.2%"]}
            />
            <Resumecontent
              title="10TH BOARD ICSE [Carmel Cvt. Sr. Sec. School, Raigarh] "
              date="2002 - 2012"
              content={["Percentage: 86%"]}
            />
              <h3 className="resume-title">Academic Projects</h3>
              <Resumecontent
                  title="Blood Bank Management System and web portal"
                  content={[
                      "Created a web application to assist searching for blood availability at various hospitals\n" +
                      "by maintaining a common database for blood availability details, system also provides people to join as a donor, gives suggestions to the\n" +
                      "particular donor based on Geo‑location of nearby hospitals with specific blood requirements.",
                      " Learned about object oriented design pat‑\n" +
                      "terns, agile methodology, class diagram and wireframes"
                  ]}
              />
              <h3 className="resume-title">Extracurricular Activities</h3>
              <Resumecontent
                  title="Technical Lead [Computer Society of India, LNMIIT chapter]"
                  content={[
                      "Provided tech workshop on Android application development to students.",
                      "Created android app for CSI to help facilitate staff and students"
                  ]}
              />
              <Resumecontent
                  title="Writer and Performer [Rendition - Dramatics society of LNMIIT]"
                  content={[
                      "Written sketches and performed for our dramatics society of college",
                      "Won Vivacity-2016 (college fest), stage play"
                  ]}
              />
            {/*<h3 className="resume-title">Ranks and Achivements</h3>*/}
            {/*<Resumecontent*/}
            {/*  title=""*/}
            {/*  content={[*/}
            {/*    `Current rank in Spoj ${spojRank}`,*/}
            {/*    `Current rank in HackerRank  ${hackerrank}`,*/}
            {/*    "Top Performer in Code-Break 1.0",*/}
            {/*    "Participant in Hack-A-Bit 2019",*/}
            {/*  ]}*/}
            {/*/>*/}
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
